import { TemplateData, TemplateParams } from '.';

const achievementRequestAchievementDenied = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementRequestAchievementDeniedDescription}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementRequestAchievementDenied}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    optionalMessage: {
      label: messages.commonMessageFromAdmin,
      example: 'Here is your achievement.'
    },
    ...defaultPlaceholders
  },
  title: messages.achievementRequestAchievementDenied
});

export default achievementRequestAchievementDenied;
